import { apiUrl } from "utils/urls";

import axios from "axios";

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    const space_uuid = sessionStorage.getItem("space_uuid");

    if (space_uuid !== String(undefined)) {
        config.headers["SPACE-UUID"] = space_uuid;
    } else {
        delete config.headers["SPACE-UUID"];
    }

    if (token) {
        config.headers["Authorization"] = `Token ${token}`;
    } else {
        delete config.headers["Authorization"];
    }
    return config;
});

export const loginApi = async (body) => {
    const { data } = await axios.post(apiUrl("login"), body);
    return data;
};

export const logout = async () => {
    const token = { auth_token: localStorage.getItem("token") };
    const { data } = await axios.post(apiUrl("logout"), token);
    return data;
};

export const signUpApi = async (body) => {
    const { data } = await axios.post(apiUrl("signup"), body);
    return data;
};

export const userCheck = async () => {
    const { data } = await axios.get(apiUrl("user") + "/check");
    return data;
};

export const adminChangeUser = async (body) => {
    const { data } = await axios.post(apiUrl("adminChangeUser"), body);
    return data;
};

export const getExitSurvey = async (body) => {
    const { data } = await axios.get(apiUrl("exitSurvey"));
    return data;
};

export const getUserProfile = async (params) => {
    const { data } = await axios.get(apiUrl("profile"), { params });
    return data;
};

export const patchUserProfile = async (body) => {
    //  body = Formdata
    // console.log(body);
    const { data } = await axios.patch(apiUrl("profile") + `/${body.id}`, body.formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};

export const getProfileDisplayInfo = async (body) => {
    const { data } = await axios.post(apiUrl("profileDisplayInfo"), body);
    return data;
};

export const getSideMenuInfo = async () => {
    const { data } = await axios.get(apiUrl("sideMenuInfo"));
    return data;
};

export const patchGroupHide = async (body) => {
    const { data } = await axios.patch(apiUrl("sideMenuInfo"), body);
    return data;
};

export const getSpace = async () => {
    const { data } = await axios.get(apiUrl("space"));
    return data;
};

export const patchSpace = async (body) => {
    const { data } = await axios.patch(apiUrl("space"), body);
    return data;
};
